import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, of, take } from 'rxjs';

import { AuthService } from '@core/auth/auth.service';
import { OrganizationService } from '@features/organization/services/organization.service';

export const contractAdvisorSubscriptionGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const organizationService = inject(OrganizationService);
  const router = inject(Router);

  const organizationId = authService.isInternalUser()
    ? route.queryParamMap.get('organizationId')?.trim()
    : authService.getOrganizationId();

  if (!organizationId) {
    void router.navigate(['/']);
    return of(false);
  }

  return organizationService.watchContractAdvisorSubscription(organizationId).pipe(
    take(1),
    map((isSubscribed) => {
      if (isSubscribed) {
        return true;
      }

      void router.navigate(['/']);
      return false;
    }),
  );
};
